/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_OutroInputs */

const en_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To exercise any of these rights, contact us at `)
};

const de_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um eines dieser Rechte auszuüben, kontaktieren Sie uns unter `)
};

const fr_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour exercer l'un de ces droits, contactez-nous à `)
};

const es_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ejercer cualquiera de estos derechos, contáctenos en `)
};

const it_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per esercitare uno di questi diritti, contattaci all'indirizzo `)
};

const nl_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om een van deze rechten uit te oefenen, neem contact met ons op via `)
};

const pl_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aby skorzystać z któregokolwiek z tych praw, skontaktuj się z nami pod adresem `)
};

const fi_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käyttääksesi näitä oikeuksia, ota yhteyttä osoitteeseen `)
};

const da_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For at udøve nogen af disse rettigheder, kontakt os på `)
};

const sv_privacy_rights_outro = /** @type {(inputs: Privacy_Rights_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För att utöva någon av dessa rättigheter, kontakta oss på `)
};

/**
* | output |
* | --- |
* | "To exercise any of these rights, contact us at" |
*
* @param {Privacy_Rights_OutroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_outro = /** @type {((inputs?: Privacy_Rights_OutroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_OutroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_outro(inputs)
	if (locale === "fr") return fr_privacy_rights_outro(inputs)
	if (locale === "es") return es_privacy_rights_outro(inputs)
	if (locale === "it") return it_privacy_rights_outro(inputs)
	if (locale === "nl") return nl_privacy_rights_outro(inputs)
	if (locale === "pl") return pl_privacy_rights_outro(inputs)
	if (locale === "fi") return fi_privacy_rights_outro(inputs)
	if (locale === "da") return da_privacy_rights_outro(inputs)
	if (locale === "sv") return sv_privacy_rights_outro(inputs)
	return en_privacy_rights_outro(inputs)
});